import {
    TextWidget,
    NumberWidget,
    RadioWidget,
    SelectWidget,
    TextAreaWidget,
    ToggleWidget,
    TextListWidget,
    UnitInputWidget,
    CurrencyWidget,
    KeyValueWidget,
    KeyValueWidgetUnit,
    KeyToggleValueWidgetUnit,
    CheckBoxWidget,
    DateWidget,
    MultiSelectWidget,
    MultiSelectWidget_OtherText,
    MinMaxUnitWidget,
    SelectWidget_OtherText,
    ChipListWidget,
    TimeWidget,
    CustomTag,
    DateRangeWidget,
    TimeRangeWidget,
    NumberRangeWidget,
    AddressWidget
} from "./InputWidgets";
import Typography from '@material-ui/core/Typography';
import { Grid, makeStyles, withStyles } from '@material-ui/core'
import { useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { Palette } from "@material-ui/icons";
import { checkFilled } from "../utils/traits";


const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 45,
        '&$expanded': {
            minHeight: 55,
        },
    },
    content: {
        '&$expanded': {
            margin: '8px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);

const useStyles = makeStyles((theme) => ({
    inputContainer: {
        width: '100%',
        '& > *:not(:last-child)': {
            borderBottom: '1px solid rgba(0, 0, 0, 0.10)',
            paddingBottom: theme.spacing(2),
            marginBottom: theme.spacing(3),
        },
        '& > *:last-child': {
            marginBottom: theme.spacing(1),
        }
    }
}));

export default function WidgetComponent({ traitGroups, onChange }) {
    const classes = useStyles();

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const onWidgetChange = (traitGroupIndex, traitIndex) => (value) => {
        console.log(`Updating ${traitGroupIndex} ${traitIndex} with ${value}`)
        // update the tagIds value, and call onChange
        const updatedTraits = JSON.parse(JSON.stringify(traitGroups));
        if (traitGroupIndex >= 0 && traitIndex >= 0) {
            if(Array.isArray(value) && value[0]==="is_applicable_flag" && typeof value[1]==="boolean"){
                updatedTraits[traitGroupIndex].traits[traitIndex] = {
                    ...updatedTraits[traitGroupIndex].traits[traitIndex],
                    is_applicable: value[1]
                }
            }
            else{
                updatedTraits[traitGroupIndex].traits[traitIndex] = {
                    ...updatedTraits[traitGroupIndex].traits[traitIndex],
                    currentValue: value
                }
                updatedTraits[traitGroupIndex].is_filled = checkFilled(updatedTraits[traitGroupIndex])
            }
            //set the trait group to a colour
            onChange(updatedTraits);
            console.log(updatedTraits)
        }
    }

    const onCustomTagChange = (i) => (trait) => {
        // const updatedTraits = JSON.parse(JSON.stringify(traits));
        // if (i >= 0) {
        //     updatedTraits[i] = { ...updatedTraits[i], ...trait }
        //     onChange(updatedTraits);
        // }
    }

    const onCustomTraitRemove = (index) => () => {
        // let updatedTraits = JSON.parse(JSON.stringify(traits));
        // updatedTraits = updatedTraits.filter((_t, i) => i !== index);
        // console.log({ index, traits, updatedTraits })
        // onChange(updatedTraits);
    }

    let groupedWidgets = traitGroups.map((traitGroup, traitGroupIndex) => {
        return (
            <Accordion square expanded={expanded === traitGroup.trait_group}   onChange={handleChange(traitGroup.trait_group)} key={traitGroup.trait_group_id}>

                <AccordionSummary expandIcon={<ExpandMoreIcon />} style={traitGroup?.is_filled ? { backgroundColor: "#0097a7", color:"white"}:{}}>
                    <Typography >{traitGroup.trait_group}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ marginLeft: 8 }} className={classes.inputContainer}>
                        {
                            traitGroup.traits.map((tag, i) => {
                                switch (tag.widget_type) {
                                    case 'TextWidget':
                                        return <TextWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'TextAreaWidget':
                                        return <TextAreaWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'NumberWidget':
                                        return <NumberWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'RadioWidget':
                                        return <RadioWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'SelectWidget':
                                        return <SelectWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'ToggleWidget':
                                        return <ToggleWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'CustomTag':
                                        return <CustomTag {...tag} key={i} questionIndex={i + 1} handleChange={onCustomTagChange(traitGroupIndex, i)} onDelete={onCustomTraitRemove(traitGroupIndex, i)} />
                                    case 'CheckBoxWidget':
                                        return <CheckBoxWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'DateWidget':
                                        return <DateWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'TimeWidget':
                                        return <TimeWidget  {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'TextListWidget':
                                        return <TextListWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'KeyValueWidget':
                                        return <KeyValueWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'KeyValueWidgetUnit':
                                        return <KeyValueWidgetUnit {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'KeyToggleValueWidgetUnit':
                                        return <KeyToggleValueWidgetUnit {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'SelectWidget_OtherText':
                                        return <SelectWidget_OtherText {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'MultiSelectWidget':
                                        return <MultiSelectWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'MultiSelectWidget_OtherText':
                                        return <MultiSelectWidget_OtherText {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'UnitWidget':
                                    case 'NumberWidget_Unit':
                                        return <MinMaxUnitWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'CurrencyWidget':
                                        return <CurrencyWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'MinMaxUnitWidget':
                                        return <MinMaxUnitWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'DateRangeWidget':
                                        return <DateRangeWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'TimeRangeWidget':
                                        return <TimeRangeWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    case 'NumberRangeWidget':
                                        return <NumberRangeWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    // case 'AddressWidget':
                                        // return <AddressWidget {...tag} key={i} questionIndex={i + 1} handleChange={onWidgetChange(traitGroupIndex, i)} />
                                    default:
                                        return <h1> todo {tag.widgetType}</h1>;
                                }
                            })
                        }
                    </div>
                </AccordionDetails>
            </Accordion >
        )
    });
    return <>{groupedWidgets}</>;
}
